<div class="row margin-top-20">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="border-div">
      <div class="d-flex chart-box-header margin-bottom-0 align-item-center">
        <h2 class="mainhead mr-auto mainhead2 margin-bottom-15" *ngIf="PortfolioName=='My Portfolio'" style="margin-bottom:40px !important;"><span class="text myPortfolioNormalHeading">My Pending Properties</span></h2>
        <h2 class="mainhead mr-auto mainhead2 margin-bottom-15" *ngIf="PortfolioName!='My Portfolio'" style="margin-bottom:40px !important;"><span class="text myPortfolioNormalHeading">{{PortfolioName}}'s Pending Properties</span></h2>
      </div>
      <div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="table-fixed table-v2 table-hd-line">
              <div class="table-responsive">
                <table class="table basictable row-border hover">
                  <thead>
                    <tr>
                      <th style="width:100px">Tenant Name</th>
                      <!--<th style="width:100px">Pipeline</th>-->
                      <th style="width:100px">Status</th>
                      <th style="width:100px">City</th>
                      <th style="width:100px">State</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let properties of pendingProperties;let i = index ">
                      <td>
                        <p>
                          <a href="javascript:void(0);" routerLink="/viewproperty/{{properties.Guid}}" [queryParams]="{'prevroute':'Market Snapshot',link:'market-snapshot',UserGuid:this.UserGuid}">{{ properties.PropertyName }}</a>
                        </p>
                      </td>
                      <td class="tag-small"><p [ngClass]="{'greentextlabel':properties.OfferStatus === 'Offer Accepted','not-available':properties.OfferStatus !== 'Offer Accepted'}">{{ properties.OfferStatus }}</p></td>
                      <td><p>{{properties.City}}</p></td>
                      <td><p>{{properties.State}}</p></td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr *ngIf="pendingProperties?.length == 0 ">
                      <td colspan="12" class="odd no-data-available">
                        <div class="nodata">
                          <i class="fa fa-exclamation-triangle icon"></i>
                          <p>No Data Available</p>
                        </div>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>

            </div>
          </div>
        </div>
     </div>
    </div>
  </div>
</div>



